import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coachtraining-course',
  templateUrl: './coachtraining-course.component.html',
  styleUrls: ['./coachtraining-course.component.scss']
})
export class CoachtrainingCourseComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Capacitação
   */
  public departmentId: string = '26';

  constructor() { }

  ngOnInit(): void {
  }

}
